import { useEffect, useState } from "react";
import { IconClearDocument, IconClinch, IconSend } from "../Icons/Icons.mjs";
import { useDispatch } from "react-redux";
import { addMessage, addMessageFileUpload } from "../../store/slices/sessionSlice.mjs";
import InputFile from "../UI/InputFile/InputFile.mjs";
import { sessionAPI } from "../../api/sessionAPI.mjs";

import "./SendMessage.scss";
export default function SendMessage({}) {
  const [value, setValue] = useState("");
  const [file, setFile] = useState(null);

  const dispatch = useDispatch();

  return (
    <div className="send-message">
      {file == null && (
        <InputFile
          accept="image/jpeg"
          setFile={(file) => {
            setFile(file);
          }}
        >
          <IconClinch classSvg={"cursor-pointer"} />
        </InputFile>
      )}
      {file == null && (
        <input
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
          placeholder="Введите запрос"
          onKeyDown={(e) => {
            if (e?.keyCode === 13 && value) {
              dispatch(addMessage(value));
              sessionAPI.sendMessage({ message: value });
              setValue("");
            }
          }}
        ></input>
      )}
      {file != null && (
        <div className="send-message__file">
          <div>{file.name}</div>
          <IconClearDocument
            classSvg={"cursor-pointer"}
            onClick={() => {
              setFile(null);
            }}
          />
        </div>
      )}
      <IconSend
        classSvg={"cursor-pointer"}
        onClick={() => {
          if (file == null) {
            if (value) {
              dispatch(addMessage(value));
              sessionAPI.sendMessage({ message: value });
              setValue("");
            }
          } else {
            var reader = new FileReader();
            reader.onload = function (event) {
              const fileContent = btoa(
                new Uint8Array(event.target.result).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              );
              let id = new Date().toISOString();
              dispatch(addMessageFileUpload(id));
              sessionAPI.uploadFile(id, fileContent);
              sessionAPI.sendMessage({ id, photoBuffer: fileContent });
              setFile(null);
            };

            reader.readAsArrayBuffer(file);
          }
        }}
      />
    </div>
  );
}
